import { PBRMaterial } from '@babylonjs/core';
import { Zed } from '@modules/core';
import { BaseSystem, SystemOperationDefinition } from '@modules/core/src/injectable/System';
import { clearArchetype } from '@modules/standard';
import { World } from 'miniplex';

import { MeshType } from '../component/data/DanjiMesh';
import { Entity } from '../Entity';
/**
 * 설명 추가 필요
 *
 * @group System
 * @category System
 */
export class ItemHoSystem implements BaseSystem {
  static readonly INJECTABLE_TOKEN = Symbol.for('ItemHoSystem');

  //------------------------------------------------------------------------------------
  // #### System Base ####
  //------------------------------------------------------------------------------------
  private readonly targetArchetype;
  
  private targetHoId: number | undefined;

  //-----------------------
  constructor({ [Zed.WORLD_TOKEN]: world }: { [Zed.WORLD_TOKEN]: World<Entity> }) {
    this.targetArchetype = world.with('ItemHo', 'DanjiMeshes');
    this.targetArchetype.onEntityAdded.subscribe((entity) => {
      entity.DanjiMeshes.danjiMeshes.forEach((dm) => {
        if (dm.type === MeshType.DONG_ITEM_HO) {
          dm.meshes.forEach((m) => {
            if (m.material && m.material instanceof PBRMaterial) {
              m.material.alpha = 0;
            }
          });
        }
      });
    });
  }

  dispose() {
    clearArchetype(this.targetArchetype);
  }

  // --------------------------------
  public getItemHoEntity(hoId?: number) {
    return this.targetArchetype.entities.find((e) => e.ItemHo.meta.ho_id === hoId);
  }
  public getItemHoMesh(hoId: number) {
    const entity = this.getItemHoEntity(hoId);
    return entity?.DanjiMeshes.danjiMeshes.at(0)?.meshes.at(0);
  }
  public setTargetItem(hoId?: number) {
    this.targetHoId = hoId;
    this.targetArchetype.entities.forEach((e) => {
      const mesh = e.DanjiMeshes.danjiMeshes.at(0)?.meshes.at(0);
      if (mesh) {
        mesh.setEnabled(e.ItemHo.meta.ho_id === hoId);
      }
    });
  }

  public getTargetEntity() {
    if (!this.targetHoId) return undefined;
    
    return this.getItemHoEntity(this.targetHoId);
  }
  // --------------------------------
  readonly operations: SystemOperationDefinition[] = [];
}
